import React from 'react';
import Footer from '../../Shared/Footer/Footer';
import Banner from '../Banner/Banner';
import Navbar from '../Navbar/Navbar';

const PageSix = () => {
    return (
        <div>
            <Navbar />
            <Banner />
            <Footer />

        </div>
    );
};

export default PageSix;